export default "__VITE_ASSET__dDSJLAs7__"